/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationPosition } from '../models/AccommodationPosition';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationPositionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a AccommodationPosition resource.
     * Retrieves a AccommodationPosition resource.
     * @param id AccommodationPosition identifier
     * @param listingType AccommodationPosition identifier
     * @param listingId AccommodationPosition identifier
     * @param category
     * @returns AccommodationPosition AccommodationPosition resource
     * @throws ApiError
     */
    public getPosition(
        id: string,
        listingType: string,
        listingId: string,
        category?: string,
    ): CancelablePromise<AccommodationPosition> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/score/positions/{id}/{listingType}/{listingId}',
            path: {
                id: id,
                listingType: listingType,
                listingId: listingId,
            },
            query: {
                category: category,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
